import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import noPermission from "@/images/no_permission_robot.png";

/** Replaces NoPermission.scss (11 lines). */
const NoPermission = () => {
  const { t } = useTranslation(["translation.utils"]);

  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        marginBlock: "auto",
        minHeight: "calc(100vh - 50px)",
        px: 2,
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        src={noPermission}
        alt=""
        sx={{ height: 150, width: "auto" }}
      />
      <Stack spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="h2">{t("NoPermissionTitle")}</Typography>
        <Typography variant="body1" sx={{ color: "grey.800" }}>
          {t("NoPermissionPhrase")}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default React.memo(NoPermission);
